import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSatisfiedEmojiSecondary from './svgs/SatisfiedEmojiSecondary.js';
import SvgSatisfiedEmoji from './svgs/SatisfiedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var satisfiedEmoji = (props => useIcon(SvgSatisfiedEmoji, SvgSatisfiedEmojiSecondary, props));

export { satisfiedEmoji as default };
